var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7207 13.9844C12.8717 13.1094 14.9316 12.6719 16.9004 12.6719C18.8691 12.6719 20.9108 13.1094 23.0254 13.9844C25.1764 14.8229 26.252 15.9349 26.252 17.3203V19.6719H7.54883V17.3203C7.54883 15.9349 8.60612 14.8229 10.7207 13.9844ZM6.40039 7.96875H9.90039V10.3203H6.40039V13.8203H4.04883V10.3203H0.548828V7.96875H4.04883V4.46875H6.40039V7.96875ZM20.1816 8.95312C19.2702 9.86458 18.1764 10.3203 16.9004 10.3203C15.6243 10.3203 14.5306 9.86458 13.6191 8.95312C12.7077 8.04167 12.252 6.94792 12.252 5.67188C12.252 4.39583 12.7077 3.30208 13.6191 2.39062C14.5306 1.44271 15.6243 0.96875 16.9004 0.96875C18.1764 0.96875 19.2702 1.44271 20.1816 2.39062C21.0931 3.30208 21.5488 4.39583 21.5488 5.67188C21.5488 6.94792 21.0931 8.04167 20.1816 8.95312Z",
    fill: "#EB5B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/user_plus.e12e1a4aa37fbf5829f2721c20bf5870.svg";
export { ForwardRef as ReactComponent };